<template>
	<div class="layout-container">
		<div class="header-menu shadow" style="padding:0px 20px">
			<div class="space"></div>
			<div :class="`header-menu-item ${$store.state.hasNotification?'alert-dot':''}`" @click="$app.notifications.show()"><app-icon i="notifications"></app-icon></div>
			<div class="header-menu-item" @click="$app.instance.$refs.modalUser.show()">
				{{$store.state.user?.name?.[0]}}
			</div>
		</div>
		<div class="menu shadow">
			<SideMenu />
		</div>
		<div class="page">
			<slot></slot>
		</div>
		<notification></notification>
	</div>
</template>

<script>
import Notification from './Notification.vue';
import SideMenu from "./SideMenu.vue"
export default {
	name: 'StockWebLayout',
	components: {
		SideMenu,
		Notification,
	},
	data() {
		return {

		};
	},

	mounted() {

	},

	methods: {

	},
};
</script>

<style lang="scss" scoped>
@keyframes anim-red {
	0% {
		background-color: red;
	}
	30% {
		background-color: transparent;
	}
	50% {
		background-color: red;
	}
}
.alert-dot{
	position: relative;
}
.alert-dot::after {
	content: " ";
	transition: 0.2;
	border-radius: 100px;
	height: 10px;
	width: 10px;
	margin-top: -20px;
	margin-right:-20px;
	position: absolute;
	background: red;
	animation-name: anim-red;
	animation-duration: 1.5s;
	animation-iteration-count: infinite;
}
.shadow {
	// box-shadow: 3px 3px 10px 0px rgba(50, 50, 50, 0.22);
}
.layout-container {
	.menu {
		width: 60px;
		height: 100vh;
		position: fixed;
		// background-color: linear-gradient(#5352ed, yellow);
		background-color: #5352ed;
		// z-index: 1000;
	}
	.header-menu {
		position: relative;
		display: flex;
		border-bottom: 1px solid #e8e8e8;
		position: fixed;
		top: 0;
		left: 60px;
		height: 60px;
		width: calc(100% - 60px);
		z-index: 999;
		background-color: #ffffff;
		&:stuck {
			box-shadow: 0 0 16px black;
		}
		.header-menu-item {
			display: flex;
			align-items: center;
			justify-content: center;
			height: 100%;
			width: 50px;
			transition: 0.2s;
			&:hover {
				cursor: pointer;
				background-color: #00000033;
			}
		}
	}
	.page {
		padding-top: 64px;
		margin-left: 60px;
	}
	width: "100px";
}
</style>